export default props => 
<>
    <h4 style={{textAlign:'center', width:'100%'}}>Privacy. This app does not collect any data about the users. It is just a simple calendar. For more info contact Per Eskilson at per.eskilson@gmail.com</h4>
</>
